import { render, staticRenderFns } from "./ExistingSubmissionScreen.vue?vue&type=template&id=aa1e1976"
import script from "./ExistingSubmissionScreen.vue?vue&type=script&lang=js"
export * from "./ExistingSubmissionScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports